import { cx } from '../../lib/cx';
import type { CardProps } from './types';

/**
 * The surface every piece of content sits on: white, thin border, soft shadow, 12 px radius.
 */
export const Card = ({ title, actions, flush = false, className, children }: CardProps) => (
  <section className={cx('rounded-card border border-gray-200 bg-white shadow-card', className)}>
    {title || actions ? (
      <header className="flex items-center justify-between border-b border-gray-100 px-6 py-4">
        {title ? <h2 className="text-base font-semibold text-gray-900">{title}</h2> : <span />}
        {actions}
      </header>
    ) : null}
    <div className={flush ? '' : 'p-6'}>{children}</div>
  </section>
);
